import { getAxiosInstance } from '../client';
/** Typed API functions for activity points */
export const activityPointsQueries = {
    /** GET /activity-point-tracking/latest/byUser/:userId */
    getLatestByUser: (userId) => getAxiosInstance()
        .get(`/activity-point-tracking/latest/byUser/${userId}`)
        .then((r) => r.data),
};
/** Query keys for activity points - use with TanStack Query */
export const activityPointsKeys = {
    all: () => ['activity-points'],
    latestByUser: (userId) => ['activity-points', 'latest', 'user', userId],
};
//# sourceMappingURL=activity-points.queries.js.map